export const SET_CITIES = 'SET_CITIES';
export const SET_CITY = 'SET_CITY';
export const ADD_CITY = 'ADD_CITY';
export const UPDATE_CITY = 'UPDATE_CITY';
export const REMOVE_CITY = 'REMOVE_CITY';
export const CLEAR_CITY = 'CLEAR_CITY';
export const CLEAR_CITIES = 'CLEAR_CITIES';
